import { ctxTachograph } from '@/contexts/TachographCtx';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import TachographGenerateButton from './TachographGenerateButton';
import { TachoTabs } from './TachographPopup';
import TachographVehicleData from './TachographVehicleData';
import TachographFileNameSelector from './TachographFileNameSelector';

export default function TachographTargetTab({ activeTab }: { activeTab: TachoTabs }) {
  const { t } = useTranslation();
  const tachographCtx = useContext(ctxTachograph);

  if (!tachographCtx) return null;

  return (
    <>
      <div id="target-tachograph-data">
        <h3 id="report-header-h3">{t('tachograph.vehicleSelector')}</h3>
        <TachographVehicleData isListView={false} />
        {tachographCtx.selectedRowIds.length > 0 && (
          <div id="target-tachograph-data-menu">
            {/*  - Opacity 0 until e-mail sending not implemented -
              <div style={{ opacity: '0' }}>
                
                <h3 id="report-email-header">{t('tachograph.email.title')}</h3>
                <p className="report-comment">{t('tachograph.email.description')}</p>
                <TachographEmail />
              </div>
            */}
            <div className="tachograph-radio-button-conainer">
              <TachographFileNameSelector />
            </div>
            <div className="tachograph-button-conainer">
              <TachographGenerateButton activeTab={activeTab} />
              <p className="tachograph-comment tachograph-generate-comment">
                {t('tachograph.downloadButton.description')}
              </p>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
